module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-SheerAllure.c493ed5a.jpg";